import type { IStorageBackend } from "@/domains/common/storage"
import type { IEventBus } from "@/domains/events"

import { FeatureFlagsStore } from "./feature-flags-store"

export type FeatureFlagsNamespace = {
  Store: FeatureFlagsStore
}

export type FeatureFlagsNamespaceFactoryParams = {
  storage: IStorageBackend
  eventBus: IEventBus
}

export const FeatureFlagsNamespaceFactory = {
  create({ storage, eventBus }: FeatureFlagsNamespaceFactoryParams): FeatureFlagsNamespace {
    const store = new FeatureFlagsStore(storage, eventBus)

    return {
      Store: store,
    }
  },
}
